module.exports = __webpack_public_path__ + "static/media/logo-for-navbar.cc92a937.svg";